import { computed } from 'vue';
import { formatterColTransferUnit } from '@/utils/format';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useModuleConfig } from '@rebuild/hooks/data/useModuleConfig';
import i18n, { EN, ZH, ZH_HK } from '@/locales';

const useCurrentReactive = () => {
    const sourceMap = {
        [EN]: 'infoSourceEn',
        [ZH_HK]: 'infoSourceCht',
        [ZH]: 'infoSource'
    };
    // 数据层
    const { loadModuleConfig, checkDisplayIndex } = useModuleConfig();
    const { shareholder_count } = useModuleData();


    const shareholderData = computed(() => shareholder_count.data?.data || []);
    // 计算总股东数
    const computedTotalAccount = computed(() => {
        const data = [...shareholderData.value];
        const total = data.reduce((prev, acc) => prev + acc.totalAccount, 0);
        return splitAmount(total);
    });

    // 计算总平均持股
    const computedTotalHoldings = computed(() => {
        const data = [...shareholderData.value];
        const total = data.reduce((prev, acc) => prev + acc.averageHoldings, 0);
        return splitAmount(total);
    });

    // 格式化金额
    const splitAmount = amount => {
        const [value, unit] = formatterColTransferUnit(amount, true);
        return { value, unit };
    };

    // 配置数据处理
    const openConfigColumn1 = computed(() => checkDisplayIndex(1));
    const openConfigColumn2 = computed(() => checkDisplayIndex(2));

    // 图表数据处理
    const chartData = computed(() => {
        const seenDates = new Set();
        const data = [...shareholderData.value];
        const sortedAndUniqueData = data
            .sort((a, b) => new Date(a.date) - new Date(b.date))
            .filter(item => {
                if (!seenDates.has(item.date)) {
                    seenDates.add(item.date);
                    return true;
                }
                return false;
            })
            .map(item => [item.date, item.totalAccount]);

        return [
            {
                type: 'bar',
                data: sortedAndUniqueData,
                name: i18n.t('enterprise.total-of-holdings')
            }
        ];
    });

    const formatPercentage = num => {
        if (num === 0) {
            return i18n.t('enterprise.unchanged');
        } else if (num > 0) {
            return `+${num}%`;
        } else {
            return `${num}%`;
        }
    };
    const calcPercentageStyle = num => {
        if (num > 0) return 'color: #EB5149';
        if (num < 0) return 'color: #44C970';
    };

    return {
        sourceMap,
        shareholderData,
        shareholder_count,
        computedTotalAccount,
        computedTotalHoldings,
        openConfigColumn1,
        openConfigColumn2,
        chartData,
        checkDisplayIndex,
        loadModuleConfig,
        formatPercentage,
        calcPercentageStyle
    };
}


export { useCurrentReactive };